import { firefuncs } from "config/firebase";
import { httpsCallable } from "firebase/functions";

interface SignUpData {
  email: string;
  password: string;
  displayName: string;
  city: string;
  state: string;
}

export const createUser = async (signUpData: SignUpData): Promise<any> => {
  const createUserFunc = httpsCallable(firefuncs, "createUser");

  try {
    const res = await createUserFunc(signUpData);
    console.log("create User res", res.data);
    return res.data;
  } catch (error: any) {
    console.log("Error creating user:", error);

    // Handle Firebase Cloud Functions HttpsError codes
    if (error.code === "functions/internal") {
      throw new Error(error.message);
    }
    if (error.code === "functions/invalid-argument") {
      throw new Error(error.message);
    }
    if (error.code === "functions/already-exists") {
      throw new Error(error.message);
    }
    if (error.code === "functions/unauthenticated") {
      throw new Error("Authentication required");
    }
    if (error.code === "functions/permission-denied") {
      throw new Error("Permission denied");
    }

    // If it's already a regular error, re-throw it
    throw error;
  }
};

interface AddUserToDBParams {
  userId: string;
  userDisplayName: string;
}

export const addUserToDB = ({
  userId,
  userDisplayName,
}: AddUserToDBParams): Promise<any> => {
  const addUser = httpsCallable(firefuncs, "addUserToDB");
  return addUser({
    id: userId,
    displayName: userDisplayName,
    city: "Austin", // todo: change to gps location
    profileBio: "",
  })
    .then((res) => console.log(res))
    .catch((err) => console.log(err));
};

export const addUserDataDocs = (
  userId: string,
  userEmail: string,
): Promise<any> => {
  const addUserData = httpsCallable(firefuncs, "addUserDataDocs");
  return addUserData({
    id: userId,
    email: userEmail,
  })
    .then((res) => console.log(res))
    .catch((err) => console.log(err));
};

export default {
  createUser,
  addUserToDB,
  addUserDataDocs,
};
